import React from "react";

interface IconProps {
  width?: number;
  height?: number;
  className?: string;
}

export const IssueNotFoundInDesktop: React.FC<IconProps> = ({
  width = 218,
  height = 223,
  className = ""
}) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 218 223"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M109 218C169.199 218 218 169.199 218 109C218 48.801 169.199 0 109 0C48.801 0 0 48.801 0 109C0 169.199 48.801 218 109 218Z"
      fill="url(#paint0_linear_539_1001)"
    />
    <g filter="url(#filter0_d_539_1001)">
      <mask
        id="mask0_539_1001"
        style={{
          maskType: "alpha",
        }}
        maskUnits="userSpaceOnUse"
        x={0}
        y={0}
        width={218}
        height={218}
      >
        <path
          d="M109 218C169.199 218 218 169.199 218 109C218 48.801 169.199 0 109 0C48.801 0 0 48.801 0 109C0 169.199 48.801 218 109 218Z"
          fill="url(#paint1_linear_539_1001)"
        />
      </mask>
      <g mask="url(#mask0_539_1001)">
        <path
          d="M24.0518 83.2002H196.948C199.692 83.2003 202.166 83.9078 203.948 85.041C205.733 86.1758 206.8 87.7189 206.8 89.3916V223.608C206.8 225.281 205.733 226.824 203.948 227.959C202.166 229.092 199.692 229.8 196.948 229.8H24.0518C21.3082 229.8 18.8341 229.092 17.0518 227.959C15.267 226.824 14.2002 225.281 14.2002 223.608V89.3916C14.2002 87.7189 15.267 86.1758 17.0518 85.041C18.8341 83.9078 21.3082 83.2003 24.0518 83.2002Z"
          fill="white"
          stroke="#495A74"
          strokeWidth={0.4}
        />
        <rect x={32} y={172} width={154} height={19} rx={2} fill="#B1D0FF" />
      </g>
      <g clipPath="url(#clip0_539_1001)">
        <rect
          x={125}
          y={105}
          width={60.5209}
          height={58}
          rx={4}
          fill="#F2F3F8"
        />
        <path
          opacity={0.2}
          d="M179.178 134.472C194.659 134.472 202.2 146.652 217.285 163C204.98 163 152.299 163 137.102 163C150.201 149.537 163.697 134.472 179.178 134.472Z"
          fill="#D3DAFB"
        />
        <path
          opacity={0.2}
          d="M127.649 129.934C144.196 129.934 154.902 145.701 169.696 163C150.285 163 103.277 163 85.6016 163C99.892 145.701 111.102 129.934 127.649 129.934Z"
          fill="#CDD9FF"
        />
        <path
          opacity={0.5}
          d="M155.353 130.043C158.594 130.043 161.22 127.417 161.22 124.176C161.22 120.936 158.594 118.309 155.353 118.309C152.113 118.309 149.486 120.936 149.486 124.176C149.486 127.417 152.113 130.043 155.353 130.043Z"
          fill="#D3DAFB"
        />
      </g>
      <rect x={32} y={151} width={75} height={13} rx={3} fill="#0B66E4" />
      <rect x={32} y={132} width={75} height={10} rx={2} fill="#DFEAFB" />
      <rect x={32} y={128} width={21} height={2} rx={1} fill="#DFEAFB" />
      <rect x={32} y={111} width={75} height={11} rx={2} fill="#DFEAFB" />
      <rect x={32} y={106} width={21} height={3} rx={1} fill="#DFEAFB" />
      <path
        d="M19 172V99.9203C19 96.6506 21.6506 94 24.9203 94H196.08C199.349 94 202 96.6506 202 99.9203V172"
        stroke="#495A74"
        strokeWidth={0.338301}
      />
    </g>
    <path
      d="M117.219 87H101.781C100.797 87 100 87.8954 100 89C100 90.1046 100.797 91 101.781 91H117.219C118.203 91 119 90.1046 119 89C119 87.8954 118.203 87 117.219 87Z"
      fill="#495A74"
    />
    <rect x={149} y={65} width={45} height={45} rx={22.5} fill="#00CD58" />
    <path
      d="M164.365 87.9061L168.492 92.0219L177.536 82.978"
      stroke="white"
      strokeWidth={1.64634}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <filter
        id="filter0_d_539_1001"
        x={5.28}
        y={69.92}
        width={210.44}
        height={152.44}
        filterUnits="userSpaceOnUse"
        colorInterpolationFilters="sRGB"
      >
        <feFlood floodOpacity={0} result="BackgroundImageFix" />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dy={-4.36} />
        <feGaussianBlur stdDeviation={4.36} />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.788235 0 0 0 0 0.803922 0 0 0 0 0.85098 0 0 0 0.349 0"
        />
        <feBlend
          mode="normal"
          in2="BackgroundImageFix"
          result="effect1_dropShadow_539_1001"
        />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="effect1_dropShadow_539_1001"
          result="shape"
        />
      </filter>
      <linearGradient
        id="paint0_linear_539_1001"
        x1={109}
        y1={0}
        x2={109}
        y2={218}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E3ECFA" />
        <stop offset={1} stopColor="#DAE7FF" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_539_1001"
        x1={109}
        y1={0}
        x2={109}
        y2={218}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#E3EEFA" />
        <stop offset={1} stopColor="#DAECFF" />
      </linearGradient>
      <clipPath id="clip0_539_1001">
        <rect x={125} y={105} width={60.5209} height={58} rx={4} fill="white" />
      </clipPath>
    </defs>
  </svg>
);

